import { CircularProgress, Stack } from '@mui/material';
import PropTypes from 'prop-types';

const CircularLoader = ({ size, minHeight = '5rem', color = 'primary' }) => {
    return (
        <Stack alignItems="center" justifyContent="center" sx={{ height: '100%', minHeight: minHeight }}>
            <CircularProgress size={size} color={color} />
        </Stack>
    );
};

CircularLoader.propTypes = {
    size: PropTypes.number,
    minHeight: PropTypes.string,
    color: PropTypes.string
};

export default CircularLoader;
